const useScrollToBlock = () => {
  const scrollToBlock = (id: string) => {
    const element = document.querySelector(`#${id}`)

    if (!element) return

    const top = element.getBoundingClientRect().top + window.pageYOffset - 96

    window.scrollTo({
      top,
      behavior: 'smooth'
    })
  }

  return { scrollToBlock }
}

export default useScrollToBlock
